// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-underline{position:relative}.title-underline:after{content:\"\";width:100px;height:3px;background:#f9d428;position:absolute;bottom:-7px;left:calc(50% - 50px);border-radius:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
